import React, { Suspense } from 'react'
import { CandidateTestPagePreviewComponent } from '@rankmi/ats-app'

const CandidateTestEditPreviewer = () => {
  return (
    <Suspense fallback={<div>Loading...</div>}>
      <div style={{padding: '16px'}}>
        <CandidateTestPagePreviewComponent />
      </div>
    </Suspense>
  )
}

export default CandidateTestEditPreviewer
